import React, { useEffect, useState } from 'react';
import axios from 'axios';

const CareerApplicationTable = () => {
  const [applications, setApplications] = useState([]);

  useEffect(() => {
    const fetchApplications = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/careerApplications`); // Adjust the endpoint as necessary
        setApplications(response.data);
      } catch (error) {
        console.error('Error fetching applications:', error);
      }
    };

    fetchApplications();
  }, []);

  return (
    <div className="py-12 bg-gray-50">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-4xl font-semibold text-center mb-8">Channel Partner Applications</h2>
        <div className="overflow-x-auto">
          <table className="min-w-full bg-white shadow-md rounded-lg">
            <thead className="bg-gray-200">
              <tr>
                <th className="py-3 px-5">Sr No.</th>
                <th className="py-3 px-5">Company Name</th>
                <th className="py-3 px-5">Location</th>
                <th className="py-3 px-5">Your Name</th>
                <th className="py-3 px-5">Mobile Number</th>
                <th className="py-3 px-5">Email</th>
                <th className="py-3 px-5">Date Submitted</th>
              </tr>
            </thead>
            <tbody>
              {applications.length > 0 ? (
                applications.map((app,index) => (
                  <tr key={app._id} className="border-b hover:bg-gray-100">
                    <td className="py-3 px-5">{index+1}</td>
                    <td className="py-3 px-5">{app.companyName}</td>
                    <td className="py-3 px-5">{app.location}</td>
                    <td className="py-3 px-5">{app.yourName}</td>
                    <td className="py-3 px-5">{app.mobileNumber}</td>
                    <td className="py-3 px-5">{app.email}</td>
                    <td className="py-3 px-5">{new Date(app.createdAt).toLocaleDateString()}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6" className="py-3 px-5 text-center">No applications submitted yet.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default CareerApplicationTable;
